import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const simulation: ThemedFunctor = ({ theme, $isLoading }) => css`
  border-radius: ${theme.remRounding['2XS']};
  border: 1px dashed ${theme.color.border[$isLoading ? 'neutral' : 'primary'].default.high};
`;

export const simulationContent: ThemedFunctor = ({ theme }) => css`
  padding: ${theme.remSize[150]};
`;

export const simulationAction: ThemedFunctor = ({ theme, $isLoading }) => css`
  padding: ${theme.remSize[150]};
  border-top: 1px dashed ${theme.color.border[$isLoading ? 'neutral' : 'primary'].default.high};
`;
